/**
 * Helper function to pluralize a string based on a count. If count is 1,
 * returns the singular form; otherwise, returns the plural form.
 * @param count
 * @param string
 * @param stringPlural
 * @returns
 */

export const pluralize = (count: number, string: string, stringPlural?: string): string => (
  count === 1 ? string : (stringPlural || `${string}s`)
)

/**
 * Capitalizes the first letter of a string and lowercases the rest.
 * If the input is an empty string, returns an empty string.
 */
export const capitalizeFirstLetter = (str: string): string => (
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ''
)

/**
 * Formats a search term to be used in Fuse.js search "extendedSearch" mode
 * @example
 * ```
 * 'search term' -> '"search term"'
 * 'search term, search term2' -> '"search term"|"search term2"'
 * 'some-tag, some tag' -> '"some-tag"|"some tag"'
 * 'some-tag,some tag' -> '"some-tag"|"some tag"'
 * ```
 * @param searchTerm
 */
export const formatSearchTerm = (searchTerm: string): string => {
  if (searchTerm.indexOf(',') >= 0) {
    const split = searchTerm.split(',')

    return split.map((term) => {
      const trimmed = term.trim()
      if (trimmed.indexOf(' ') !== -1) {
        return `"${trimmed}"`
      }
      return trimmed
    }).join('|')
  }

  if (searchTerm.indexOf(' ') !== -1) {
    return `"${searchTerm}"`
  }

  return searchTerm
}
